import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Store} from '@ngrx/store';

import {Api} from '../utils';
import {InitInformation} from '@models/init-information.interface';
import {RequestsHandler} from './requests.service';
import {CountriesState} from '@store/reducers';
import {POSSIBLE_COUNTRIES_LOAD, INITIAL_INFO_LOAD} from '@store/actions';
import 'rxjs/add/operator/map';

declare var google: any;

@Injectable()
export class ShipmentService {
  public initialData = new BehaviorSubject(null);
  public shipments$ = new BehaviorSubject([]);
  private defaultCountryCode = 'SE';
  constructor(private http: HttpClient,
              private api: Api,
              private handler: RequestsHandler,
              private store: Store<CountriesState>
  ) {}

  getInitialData() {
    const lang = sessionStorage.getItem('lang') || 'en';
    return this.http.get(this.api.getUrl('shipment/init?language=' + lang))
      .map((data: InitInformation) => {
        this.initialData.next(data);
        this.store.dispatch({
          type: POSSIBLE_COUNTRIES_LOAD,
          payload: this.possibleCountries
        });
        // console.log(37, data);
        this.store.dispatch({
          type: INITIAL_INFO_LOAD,
          payload: data
        });
        return data;
      })
      .catch((error): any => {
        return Observable.throw('Internal server error');
      });
  }

  search(data) {
    return this.http.post(this.api.getUrl('shipment/search'), JSON.stringify(data), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  createOrder(data) {
    return this.http.post(
      this.api.getUrl('shipment/order'),
      JSON.stringify(data),
      {headers: this.handler.headers()}
      ).catch((err: any) => {
        return Observable.throw(err);
      });

  }
  get possibleCountries() {
    const initialData = this.initialData.getValue();
    return initialData && Object.keys(initialData.countries.names)
      .map(key => ({value: key, label: initialData.countries.names[key]}));
  }
  getData(value) {
    const initialData = this.initialData.getValue();
    return initialData && initialData[value];
  }

  getCountryRules(fromCode = null, toCode = null) {
    const initialData = this.initialData.getValue();
    if (!initialData) {
      return;
    }
    let from, to;
    const { countries: { codes, names }} = initialData;
    const possibleCountries = this.possibleCountries;
    // to = codes[fromCode || this.defaultCountryCode].map(code => possibleCountries.find(({value}) => value === code));
    if (fromCode && fromCode !== this.defaultCountryCode) {
      to = possibleCountries.filter(({value}) => value === this.defaultCountryCode);
    } else {
      to = Object.keys(codes).map(code => ({value: code, label: names[code]}));
    }
    if (toCode && toCode !== this.defaultCountryCode) {
      from = possibleCountries.filter(({value}) => value === this.defaultCountryCode);
    } else {
      from = Object.keys(codes).map(code => ({value: code, label: names[code]}));
    }
    return {
      from: this.sortData(from),
      to: this.sortData(to)
    };
  }

  private sortData = (data) => data.sort(({label: labelA}, {label: labelB}) => labelA.localeCompare(labelB));

  get shipments() {
    return this.shipments$.getValue();
  }

  pushShipment(shipment: any) {
    this.shipments$.next([...this.shipments, shipment]);
  }

  removeShipment(id: number) {
    this.shipments$.next(this.shipments.filter(({details: {product_id}}) => product_id !== id));
  }

  updateShipment(index, errorData) {
    const updatedShipments = [...this.shipments];
    errorData.errors.forEach((err: any) => {
      updatedShipments[index].details[err.type] = err.val;
    });
    this.shipments$.next(updatedShipments);
  }

  updateStatus(id, status) {
    return this.http.patch(
      this.api.getUrl('account/shipments/' + id + '/status'),
      {status: status},
      {headers: this.handler.headers()}
    ).catch((err: any) => {
      return Observable.throw(err);
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/services/shipment.service.ts